import { Skeleton as SkeletonAntD } from 'antd'
import { SkeletonInputProps } from 'antd/lib/skeleton/Input'
import { ReactNode } from 'react'

import cn from '@/utils/tailwind/cn'

type Props = {
  isLoading?: boolean
  children: ReactNode
} & SkeletonInputProps
export const Skeleton = ({
  isLoading,
  children,
  className,
  ...props
}: Props) => {
  return isLoading ? (
    <SkeletonAntD.Input
      active
      className={cn('!h-4 !w-full overflow-hidden rounded', className)}
      {...props}
    />
  ) : (
    <>{children}</>
  )
}
